<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 font-weight-bold">Reportes - Ventas</h2>
        <div class="subtitle-2 grey--text">Listado de reportes disponibles para analisis de ventas.</div>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" md="6" lg="4">
        <v-card outlined>
          <v-card-title class="d-flex align-center">
            <v-icon color="grey" class="mr-2">mdi-file-document-outline</v-icon>
            Sin reportes configurados
          </v-card-title>
          <v-card-text>
            Esta seccion ya esta lista para agregar reportes de ventas adicionales.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ReportsSalesSectionView',
};
</script>
